import { USER_IN_ADMIN_FIELDS } from 'Users';

// The admin fields give getAoiRecord the full BaseUser shape. The rest are what the page shows.
export const USER_DETAILS_FIELDS = [
    ...USER_IN_ADMIN_FIELDS,
    'avatarUrl',
    'careerProfile',
    'currentSignInAt',
    'messagingEnabled',
    'sendbirdAccessToken',
    'studentEmailAddresses',
    'updatedAt',
] as const;

export const TAB_STORAGE_KEY = 'adminEditCareerProfile_currentTab';

export const TABS = [
    { id: 'edit-profile', label: 'Edit Profile' },
    { id: 'student-records', label: 'Student Records' },
    { id: 'timeline', label: 'Timeline' },
    { id: 'payments', label: 'Transactions' },
    { id: 'administration', label: 'Administration' },
    { id: 'lesson-permissions', label: 'Lesson Permissions' },
] as const;
